const CUSTOMIZATION_URL_ACTIONS = {
    SHOW: 'show',
    EDIT: 'edit',
    DUPLICATE: 'duplicate'
};

export default CUSTOMIZATION_URL_ACTIONS;